import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class ResponsiveService {

	currentBreakpointSubject: BehaviorSubject<string>;
	currentBreakpoint: Observable<string>;

	constructor() {
		this.currentBreakpointSubject = new BehaviorSubject<string>(this.getCurrentBreakpoint(window.outerWidth));
		this.currentBreakpoint = this.currentBreakpointSubject.asObservable();
	}

	setCurrentBreakpoint(w: number) {
		this.currentBreakpointSubject.next(this.getCurrentBreakpoint(w));
	}

	getCurrentBreakpoint(w: number): string {
		if (w < 576)
			return "xs";
		else if (w < 768)
			return "sm";
		else if (w < 992)
			return "md";
		else if (w < 1200)
			return "lg";
		else
			return "xl";
	}

	public get currentBreakpointValue(): string {
		return this.currentBreakpointSubject.value;
	}

	isMobile(): boolean {
		return this.currentBreakpointSubject && this.currentBreakpointSubject.value && (this.currentBreakpointSubject.value == "xs" || this.currentBreakpointSubject.value == "sm");
	}

	// detectMobile(): boolean {
	// 	return (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
	// }
}
